import { BaseResource } from './base-resource';

export class CityZip extends BaseResource {
  readonly city: string;
  readonly zip: string;
}
